import { Routes, Route } from 'react-router-dom'
import LuckyDraw from './lucky-draw/Page'
import LuckyDrawDetail from './lucky-draw/detail/Page'
import MysteryShopper from './mystery-shopper/Page'
import MysteryShopperDetail from './mystery-shopper/detail/Page'

const Page = () => {
  return (
    <Routes>
      <Route path='/lucky-draw' element={<LuckyDraw />} />
      <Route path='/lucky-draw/:id' element={<LuckyDrawDetail />} />
      <Route path='/mystery-shopper' element={<MysteryShopper />} />
      <Route path='/mystery-shopper/:id' element={<MysteryShopperDetail />} />
    </Routes>
  )
}

export default Page
